export enum TaskStatus {
    Created = "Created",
    Assigned = "Assigned",
    Selected = "Selected",
    Confirmed = "Confirmed",
    Rejected = "Rejected",
    Reassigned = "Reassigned",
    Started = "Started",
    InProgress = "InProgress",
    Completed = "Completed",
    Review = "Review",
    Verified = "Verified",
    ForRevision = "ForRevision",
    Paid = "Paid",
    Cancelled = "Cancelled",
    Archived = "Archived",
}
